import React, { useState, useEffect } from "react";
// Chakra imports
import {
  HStack,
  VStack,
  Flex,
  Box,
  Spacer,
  Table,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
  Td,
  useColorModeValue,
  Progress,
  Button,
  useDisclosure,
  Icon,
  FormControl,
  FormLabel,
  Select,
  Checkbox,
  Switch,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";// Chakra Icons
import { SettingsIcon } from "@chakra-ui/icons";
import { FaEye, FaCreditCard, FaWrench, FaCheckCircle, FaSortDown, FaArrowCircleRight } from "react-icons/fa";
// Custom components
import useGetLends from "../../hooks/useGetLends";
import Pagination from "./Pagination";
import RemitLend from "../../modals/RemitLend";
import { useAuth } from "contexts/auth";

function LendsTable({
  toolId = undefined,
  mechanicId = undefined,  
}) {

    const textColor = useColorModeValue("gray.700", "white");
    let navbarIcon = useColorModeValue("gray.500", "gray.200");

    const { auth } = useAuth();
    const [ page, setPage ] = useState(1);
    const pageLimit = 10;

    const { isOpen: isOpenRemitLend, onOpen: onOpenRemitLend, onClose: onCloseRemitLend } = useDisclosure();
    // const { isOpen: isOpenCreatePayment, onOpen: onOpenCreatePayment, onClose: onCloseCreatePayment } = useDisclosure();
    const [ lendData, setLendData ] = useState(null);
    const [ completed, setCompleted ] = useState(null);
    const [ visibleColumns, setVisibleColumns ] = useState({
      "Mechanic": true,
      "Quantity": true,
      "Remarks": true,
      "Borrowed Date": true,
      "Returned Date": true,
    });


    let { 
      lends, 
      totalLends, 
      setGettingLends, 
      gettingLends, 
      gettingLendsReqSuccess 
    } = useGetLends({ 
      page, 
      limit: pageLimit,
      toolId, 
      mechanicId,  
    });


    useEffect(() => {
      reloadTable();
    }, [page, completed]);
    
    const reloadTable = () => {
      // console.log(page, completed);
      setGettingLends(true);
    }

    const onChangeVisibleColumn = (columnName, value) => {
      const tmp = {...visibleColumns};
      tmp[columnName] = value;
      setVisibleColumns(tmp);
      // console.log(columnName, value);
    }

    return ( 
        <Flex direction="column" w="100%">
          <Box>
            <Flex direction="row" w="100%">
              {/* <HStack>
                <Text marginLeft={2}>Status</Text>
                <Select
                  onChange={(e) => {
                    if (e.target.value == 'All') {
                      setCompleted(null);
                    } else if (e.target.value == 'Ongoing') {
                      setCompleted(false);
                    } else if (e.target.value == 'Completed') {
                      setCompleted(true);
                    }
                  }}
                >
                  <option key="status-all" value="All">All</option>
                  <option key="status-ongoing" value="Ongoing">Ongoing</option>
                  <option key="status-completed" value="Completed">Completed</option>
                </Select>
              </HStack> */}
              <Box flex={1} alignSelf="center" textAlign="right">
                <Menu>
                  <MenuButton>
                    <SettingsIcon color={navbarIcon} w="24px" h="24px" />
                  </MenuButton>
                  <MenuList p="16px 8px" width="80px">
                    <Flex flexDirection="column">
                      { Object.keys(visibleColumns).map((key) => {
                          return (
                            <FormControl display="flex" 
                              alignItems="center" >
                              <FormLabel htmlFor={key} mb="0"
                              width="100%">
                                {key}
                              </FormLabel>
                              <Switch id={key} defaultChecked={visibleColumns[key]}
                                onChange={e => onChangeVisibleColumn(key, e.target.checked)}/>
                            </FormControl>
                          )
                        })
                      }
                    </Flex>
                  </MenuList>
                </Menu>
              </Box>
              
              
            </Flex>
          </Box>
          <Box 
            marginTop={2}
            maxHeight={"74vh"}
            overflowY={"auto"}
          >
            <Table variant="simple" color={textColor}>
              <Thead>
                <Tr my=".8rem" p={2} color="gray.400">
                  { visibleColumns["Mechanic"] 
                  ? <Th p={2} color="gray.400">Mechanic</Th>
                  : null }
                  { visibleColumns["Quantity"] 
                    ? <Th p={2} color="gray.400">Quantity</Th>
                    : null }
                  { visibleColumns["Remarks"] 
                    ? <Th p={2} color="gray.400">Remarks</Th>
                    : null }
                  { visibleColumns["Borrowed Date"] 
                    ? <Th p={2} color="gray.400">Borrowed Date</Th>
                    : null }
                  { visibleColumns["Returned Date"] 
                    ? <Th p={2} color="gray.400">Returned Date</Th>
                    : null }
                  { auth.role == 'clerk' 
                    ? <Th p={2} color="gray.400">Actions</Th>
                    : null
                  }
                 
                   
                </Tr>
              </Thead>
              <Tbody>
                {gettingLends ? 
                  <Tr my=".8rem" >
                    <Td minWidth={{ sm: "250px" }} p={2} colSpan={4}>
                      <Progress isIndeterminate />
                    </Td>
                  </Tr>
                  : lends.map((o) => {
                    return (
                      <Tr my=".8rem" p={2} key={`lend-row-${o.id}`}>
                        { visibleColumns["Mechanic"] 
                          ? <Td p={2}>
                              <Text>{o.mechanic.firstName} {o.mechanic.lastName}</Text>
                            </Td>
                          : null
                        }
                        { visibleColumns["Quantity"] 
                          ? <Td  p={2}>
                              <Text>{o.quantity}</Text>
                            </Td>
                          : null 
                        } 
                        { visibleColumns["Remarks"] 
                          ? <Td  p={2}>
                              <Text>{o.remarks}</Text>
                            </Td>
                          : null 
                        } 
                        { visibleColumns["Borrowed Date"] 
                          ? <Td  p={2}>{new Date(o.borrowedAt).toLocaleString()}</Td>
                          : null 
                        }
                        { visibleColumns["Returned Date"] 
                          ? <Td  p={2}>
                            { o.remittedAt
                              ? new Date(o.remittedAt).toLocaleString()
                              : ""
                            }</Td>
                          : null 
                        }

                        { auth.role == 'clerk' 
                            ? <Td  p={2}>
                                <Flex flexDirection="row">
                                  { o.remittedAt 
                                    ? null 
                                    : <Button 
                                      key={`action-${o.id}-view-lend`}
                                      p="0px" bg="transparent" 
                                      title="Return Tool"
                                      onClick={() => {
                                        setLendData(o);
                                        onOpenRemitLend(true);
                                      }}
                                    >
                                      <Flex color={textColor} cursor="pointer" align="center" p="12px">
                                        <Icon as={FaArrowCircleRight} me="2px" />
                                      </Flex>
                                    </Button>
                                  }
                                </Flex>
                              </Td>

                          : null
                        }
                      </Tr>
                    );
                  })
                }
                
              </Tbody>
            </Table>
          </Box>
          <Spacer />
          { totalLends != 0
            ? <Pagination 
              totalItems={totalLends}
              pageRows={pageLimit}
              currentPage={page}
              onPageChanged={setPage}
            />
            : null
          }

          <RemitLend
              isOpen={isOpenRemitLend}
              onClose={() => {
                setLendData(null);
                onCloseRemitLend();
              }}
              lendData={lendData}
              successCallback={reloadTable}
          />

        
        </Flex>
    )
}


export default LendsTable;